export const loadImage = (path) =>
  new Promise((resolve, reject) => {
    const image = new Image()

    image.onload = () => resolve(image)
    image.onerror = () => reject(new Error('Error loading image from ' + path))
    image.src = path
  })

export const loadImages = (paths) => Promise.all(paths.map(loadImage))
